export const round = (number) => Math.round(number * 100) / 100;
